<div class="sign-up-container">
    <div class="banner-container">
        <img src="assets/images/backgrounds/cz-poster.jpg" />
    </div>
    <div class="form-container p-l-30 p-r-30">
        <form [formGroup]="formGroup.group">
            <div class="logo">
                <img src="assets/images/logo/logo-dark-bit.svg" />
                <div><b>CustomerZone</b></div>
            </div>
            <div class="info m-t-20">Join Bitdefender CustomerZone</div>
            <div class="sub-info m-t-10">Please enter your details:</div>

            <div class="d-flex">
                <div class="d-flex flex-direction-column form-control">
                    <label>Company </label>
                    <mat-form-field
                        appearance="outline"
                        class="input-form-field w-60-percent m-t-10"
                    >
                        <input
                            [placeholder]="companyPlaceholder"
                            formControlName="companyName"
                            matInput
                            maxlength="255"
                            required
                            type="text"
                        />
                    </mat-form-field>
                </div>
                <div class="d-flex flex-direction-column form-control">
                    <label>License Key </label>
                    <mat-form-field
                        appearance="outline"
                        class="input-form-field w-60-percent m-t-10"
                    >
                        <input
                            [placeholder]="LicenseKeyPlaceholder"
                            formControlName="licenseKey"
                            matInput
                            maxlength="255"
                            required
                            type="text"
                        />
                    </mat-form-field>
                </div>
            </div>
            <div class="d-flex">
                <div class="d-flex flex-direction-column form-control">
                    <label>Email address</label>
                    <mat-form-field
                        appearance="outline"
                        class="input-form-field w-60-percent m-t-10"
                    >
                        <input
                            [placeholder]="emailPlaceholder"
                            formControlName="email"
                            matInput
                            maxlength="255"
                            required
                            type="text"
                        />
                    </mat-form-field>
                </div>

                <div class="d-flex flex-direction-column form-control">
                    <label>Phone</label>
                    <mat-form-field
                        appearance="outline"
                        class="input-form-field w-60-percent m-t-10"
                    >
                        <input
                            [placeholder]="phonePlaceholder"
                            formControlName="phone"
                            matInput
                            maxlength="255"
                            required
                            type="text"
                        />
                    </mat-form-field>
                </div>
            </div>
            <div class="d-flex">
                <div class="d-flex flex-direction-column form-control">
                    <label>First name</label>
                    <mat-form-field
                        appearance="outline"
                        class="input-form-field w-60-percent m-t-10"
                    >
                        <input
                            [placeholder]="firstNamePlaceholder"
                            formControlName="firstName"
                            matInput
                            maxlength="255"
                            required
                            type="text"
                        />
                    </mat-form-field>
                </div>

                <div class="d-flex flex-direction-column form-control">
                    <label>Last name</label>
                    <mat-form-field
                        appearance="outline"
                        class="input-form-field w-60-percent m-t-10"
                    >
                        <input
                            [placeholder]="lastNamePlaceholder"
                            formControlName="lastName"
                            matInput
                            maxlength="255"
                            required
                            type="text"
                        />
                    </mat-form-field>
                </div>
            </div>
            <div class="terms-div d-flex">
                <mat-checkbox formControlName="tc_accepted"
                    >I have read and agree to the <a class="m-t-negative-3"> Terms of use </a>
                </mat-checkbox>
                <button
                    (click)="signUp()"
                    [disabled]="!formGroup.group.valid"
                    class="join-button"
                    color="primary"
                    mat-stroked-button
                >
                    SIGN UP
                </button>
            </div>
            <!--            <div>-->
            <!--                <re-captcha [siteKey]="environment.siteKey" (resolved)="resolved($event)" (errored)="errored($event)"-->
            <!--                            errorMode="handled"></re-captcha>-->
            <!--            </div>-->
            <div class="contact m-t-10">If you encounter any difficulty, please contact us <a class="m-t-negative-1">here</a></div>
        </form>
    </div>
</div>
